import React, { Component } from 'react'
import { WithCommon } from '../Common'

export default WithCommon(
  class extends Component {
    render() {
      return <div style={{ fontWeight: 'bold', color: '#333' }}>日程管理</div>
    }
  }
)
